import {put,takeLatest,call} from 'redux-saga/effects'
import * as superUserService from "../../../services/superUserService"
import {
    SELECT_SUPERUSER,
    SELECT_SUPERUSER_SUCCESS,
    SELECT_SUPERUSER_ERROR
}
    from "../../actions/superuser"

function* selectSuperUserSaga(action) {
    try {
        const data=yield call(superUserService.SelectSuperUser,action.payload)
        yield put({
            type: SELECT_SUPERUSER_SUCCESS,
            payload: data
        })

    } catch(error) {
        yield put({
            type: SELECT_SUPERUSER_ERROR,error: error.data
        })
    }
}


export function* selectSuperUserSagaWatcher() {
    yield takeLatest(SELECT_SUPERUSER,selectSuperUserSaga)
}